export default __webpack_public_path__ + "static/media/JuniousBlue.bdcb09a3.gif";